import { ColorOptions, TextNewProps } from '@jfs/ui-new'

export const styles = {
  titleText: {
    fontSize: 12,
    color: 'PRIMARY_GREY' as ColorOptions,
    lineHeight: 18,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  mainView: {},
}
